import { PlayerDetailsViewModel } from './player.model';

export class PlayerListListViewModel{
        ListId: string;
        OrgId: number;
        Description: string;
        Category: string
        NumberOfPlayers: number;
        CreatedBy: string;
        Archived: boolean;
        CreatedByFirstName: string;
        CreatedByLastName: string;
        IsMyList: boolean;
        PlayerListPlayer: PlayerListPlayer[];
    }

    export class PlayerListDetailsViewModel
    {
        ListId: string;
        OrgId: number;
        Description: string;
        Category: string;
        CreatedBy: string;
        Archived: boolean;
        players: PlayerDetailsViewModel[];
        IsMyList: boolean;
        PlayerListSecurity: PlayerListSecurity[];
        CanEdit: boolean;
        //OrgUsers: usersinfo[];
        
    }

    export class PlayerListPlayer{  
        Position: number;
        FirstName: string;
        LastName: string;
    }

    export class PlayerListSecurity
    {
        ListId : string;
        UserId : string;        
        User_Id : string;
        value: boolean;
        CanEdit: boolean;
    }